import {
  pxToRem,
  responsiveFontSizes,
  typography as defaultTypography,
} from '@larvitu/shared/mui/feature-theme-provider';

import { font } from '../styles/fonts';

import type { Typography, TypographyOptions } from '@mui/material/styles/createTypography';

export const typography: TypographyOptions = {
  ...defaultTypography,
  fontFamily: `${font.style.fontFamily}, sans-serif`,
  h1: {
    fontFamily: `${font.style.fontFamily}`,
    fontWeight: 400,
    lineHeight: 80 / 64,
    // fontSize: pxToRem(40),
    fontSize: pxToRem(64),
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
  },
  h2: {
    fontFamily: `${font.style.fontFamily}`,
    fontWeight: 400,
    lineHeight: 64 / 48,
    // fontSize: pxToRem(32),
    fontSize: pxToRem(46),
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    fontFamily: `${font.style.fontFamily}`,
    fontWeight: 400,
    lineHeight: 1.5,
    // fontSize: pxToRem(24),
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
  },
  h4: {
    fontFamily: `${font.style.fontFamily}`,
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
  h5: {
    fontFamily: `${font.style.fontFamily}`,
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  h6: {
    fontFamily: `${font.style.fontFamily}`,
    fontWeight: 400,
    lineHeight: 28 / 18,
    fontSize: pxToRem(17),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 28 / 16,
    fontSize: pxToRem(16),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 26 / 14,
    fontSize: pxToRem(14),
  },
  subtitle3: {
    fontWeight: 600,
    lineHeight: 24 / 13,
    fontSize: pxToRem(13),
  },
  body1: {
    fontWeight: 400,
    lineHeight: 28 / 16,
    fontSize: pxToRem(16),
  },
  body2: {
    fontWeight: 400,
    lineHeight: 26 / 14,
    fontSize: pxToRem(14),
  },
  body3: {
    fontWeight: 400,
    lineHeight: 24 / 13,
    fontSize: pxToRem(13),
  },
  caption: {
    lineHeight: 20 / 12,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 600,
    lineHeight: 20 / 12,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 600,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    textTransform: 'capitalize',
  },
};
